/* eslint-disable jsx-a11y/click-events-have-key-events */
import { FunctionComponent } from 'react';

import styles from './ActivityMultiSelectItem.module.scss';

type MultiSelectItemProps = {
  idx: number;
  label: string;
  isActive?: boolean;
  color?: string;
  onClick: (idx: number) => void;
};

type FC = FunctionComponent<MultiSelectItemProps>;

const MultiSelectItem: FC = ({
  idx,
  label = 'MultiSelectItem',
  isActive = false,
  color,
  onClick,
}: MultiSelectItemProps) => {
  const activeClass = isActive ? 'active' : '';
  const hasDot = color !== undefined;
  const DotColor = hasDot && color !== undefined && isActive ? color : '#C4C4C4';
  const handleClick = () => {
    onClick(idx);
  };

  return (
    <div className={[styles.container, styles[activeClass]].join(' ')} role="button" tabIndex={0} onClick={handleClick}>
      {hasDot && <span className={styles.dot} style={{ background: DotColor }} />}
      {label}
    </div>
  );
};

export default MultiSelectItem;
